import { CollectibleService } from '@portals/api';
import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { finalize, tap } from 'rxjs';
import * as Highcharts from 'highcharts';

// Import the Highcharts modules

import Wordcloud from 'highcharts/modules/wordcloud';
import { BaseComponent } from '@portals/core';
Wordcloud(Highcharts);
@Component({
	selector: 'portals-tag-cloud',
	templateUrl: './tag-cloud.component.html',
	styleUrls: ['./tag-cloud.component.scss'],
})
export class TagCloudComponent extends BaseComponent implements AfterViewInit {
	@Input() projectID!: number;
	@Input() currentFilters!: any;
	wordCount: { counter: number; words: any[]; autorefresh: boolean } = { counter: 0, words: [], autorefresh: true };
	topKeyWords: { phrase: string; count: number }[] = [];
	constructor(private collectibleService: CollectibleService, private cdr: ChangeDetectorRef) {
		super();
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes['currentFilters']) {
			const previousValue = changes['currentFilters'].previousValue;
			const currentValue = changes['currentFilters'].currentValue;

			if (!this.isEqual(previousValue, currentValue)) {
				this.fetchData(currentValue);
				this.cdr.detectChanges();
			}
		}
	}
	private isEqual(obj1: any, obj2: any): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}
	fetchData(filter: any) {
		console.log('moment fetching data');
		this.collectibleService
			.momentQueryByProject(this.projectID, filter)
			.pipe(
				tap((data) => {
					const dt = data.slice(0, 50);
					const totalCount = dt.reduce((acc: any, item: any) => acc + item.count, 0);
					const val = dt.map((item: any) => ({
						weight: (item.count / totalCount) * 100,
						...item,
					}));
					this.topKeyWords = dt
						.sort((a: any, b: any) => b.count - a.count)
						.slice(0, 7)
						.map((item: any) => ({ phrase: item.name, count: item.count }));
					console.log(data);
					const options: Highcharts.Options = {
						plotOptions: {
							wordcloud: {
								placementStrategy: 'center',
								spiral: 'rectangular',
								maxFontSize: 40,
							},
						},
						chart: {
							// width: 700,
						},
						accessibility: {
							screenReaderSection: {
								beforeChartFormat: '<h5>{chartTitle}</h5>' + '<div>{chartSubtitle}</div>' + '<div>{chartLongdesc}</div>' + '<div>{viewTableButton}</div>',
							},
						},
						series: [
							{
								type: 'wordcloud',
								data: val,
								name: 'Occurrences',
							},
						],
						title: {
							text: '',
						},
						tooltip: {
							headerFormat: '<span style="font-size: 16px"><b>{point.key}</b></span>',
							pointFormat: '<br>Count: <b>{point.count}</b>',
						},
					};

					this.chart = Highcharts.chart('wordCloudContainer', options);
				})
			)
			.subscribe();
	}
	ngAfterViewInit() {
		this.fetchData(this.currentFilters);
	}
}
